/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
export const getAccessedAt = (): number => Date.now();
